export default __webpack_public_path__ + "static/media/logo-sm.4ce1f3a1.png";